// === Product form

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // === If has upsells or not

        let hasUpsells = false;
        let upsellItems = [];

        const activeUpsells = document.querySelectorAll(`[data-product-upsell="product-upsells-fetch"]:has(input[data-product-upsell-toggle]:checked)`);
        if (activeUpsells.length > 0) {
          activeUpsells.forEach((activeUpsell) => {
            if (!activeUpsell.querySelector('button[type="submit"]').disabled) {
              const upsellVariantId = activeUpsell.querySelector('input[name="id"]').value;
              const upsellQuantity = activeUpsell.querySelector('input[name="quantity"]') ? parseInt(activeUpsell.querySelector('input[name="quantity"]').value) : 1;

              upsellItems.push({
                id: upsellVariantId,
                quantity: upsellQuantity
              });
            }
          });

          if (upsellItems.length > 0) {
            hasUpsells = true;
          }
        }
        
        if (hasUpsells) {
          this.fetchWithUpsells(upsellItems);
        } else {
          this.fetchOriginal();
        }
      }

      fetchWithUpsells(upsellItems) {
        // === Add current product
        const thisVariantId = this.form.querySelector('[name=id]').value;
        const thisVariantQuantity = document.getElementById(`Quantity-${this.dataset.sectionId}`) ? parseInt(document.getElementById(`Quantity-${this.dataset.sectionId}`).value) : 1;
        upsellItems.unshift({
          id: thisVariantId,
          quantity: thisVariantQuantity
        });

        // === Fetch
        let formData = {
          'items': upsellItems
        };

        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: thisVariantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: thisVariantId,
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            // document.body.addEventListener(
            //   'modalClosed',
            //   () => {
            //     setTimeout(() => {
            //       this.cart.renderContents(response);
            //     });
            //   },
            //   { once: true }
            // );
            quickAddModal.hide(true);
          } else {
            // this.cart.renderContents(response);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      fetchOriginal() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              // document.body.addEventListener(
              //   'modalClosed',
              //   () => {
              //     setTimeout(() => {
              //       this.cart.renderContents(response);
              //     });
              //   },
              //   { once: true }
              // );
              quickAddModal.hide(true);
            } else {
              // this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// === Product BIS form

if (!customElements.get('product-bis-form')) {
  customElements.define(
    'product-bis-form',
    class ProductBisForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.productId = this.dataset.productId;
        this.formEmail = this.querySelector('[name="product-bis-form-email"]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.formMsgSuccess = this.querySelector('[data-bis-form-success]');
        this.formMsgError = this.querySelector('[data-bis-form-error]');
        this.formMsgErrorInfos = this.querySelector('[data-bis-form-error-infos]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage(true);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // === BIS process    

        const thisVariantId = this.form.querySelector('[name=id]').value;
        if (this.formEmail && this.productId && thisVariantId && BIS !== null && BIS !== undefined) {
          BIS.create(this.formEmail.value, parseInt(thisVariantId), parseInt(this.productId))
          .then((res) => {
            this.handleErrorMessage(false, res);
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
        } else {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(isLoading = false, data) {
        this.formMsgErrorInfos.innerText = '';
        if (isLoading) {
          this.formMsgSuccess.classList.add('hidden');
          this.formMsgError.classList.add('hidden');
        } else if (data && data.status && data.status == 'OK') {
          this.formMsgSuccess.classList.remove('hidden');
        } else if (data && data.errors) {
          let errorInfos = '';
          for (var k in data.errors) { // collect all the error messages into a string
            errorInfos += ` ${data.errors[k].join(' ')}`;
          }
          if (errorInfos != '') {
            this.formMsgErrorInfos.innerText = `(${errorInfos.trim()})`;
          }
          this.formMsgError.classList.remove('hidden');
        } else {
          this.formMsgError.classList.remove('hidden');
        }
      }
    }
  );
}
